import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationStratalotTodoAppliedRuleApiService } from './organization-stratalot-todo-applied-rule-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStratalotTodoAppliedRuleApiService extends GeneratedOrganizationStratalotTodoAppliedRuleApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
